
import { Component, Vue, Prop } from 'vue-property-decorator'
import $ from 'jquery'

@Component
export default class ContentScroll extends Vue {
  @Prop() readonly scrollAreaSelector!: string
  @Prop() readonly elementsSelector!: string

  created () {
    if (!this.isMobile()) {
      window.addEventListener('resize', this.updateScrollStatus)
    }
  }

  destroyed () {
    if (!this.isMobile()) {
      window.removeEventListener('resize', this.updateScrollStatus)
    }
  }

  mounted () {
    if (this.isMobile()) {
      $(this.scrollAreaSelector).css('overflow-x', 'scroll')
    }
  }

  updated () {
    if (!this.isMobile()) {
      this.updateScrollStatus()
    }

    this.elementWidth = $(this.elementsSelector).outerWidth(true) as number

    if ($(this.elementsSelector + ' .active').length > 0) {
      const scrollArea = $(this.scrollAreaSelector)
      const index = $(this.elementsSelector + ':not([style*="display: none"])').index($(this.elementsSelector + ':not([style*="display: none"]) .active').parent())
      const currentOffset = scrollArea.scrollLeft() || 0
      if (this.elementWidth * (index + 1) - currentOffset > scrollArea[0].offsetWidth || this.elementWidth * index < currentOffset) {
        scrollArea.animate({ scrollLeft: this.elementWidth * index - (scrollArea[0].offsetWidth - this.elementWidth) / 2 }, 800)
      }
    }
  }

  private hasScroll = false

  private elementWidth = 0

  public updateScrollStatus (): void {
    const scrollArea = $(this.scrollAreaSelector)
    this.hasScroll = scrollArea.length > 0 && (scrollArea[0].offsetWidth < scrollArea[0].scrollWidth)
  }

  public scrollBack (): void {
    const scrollArea = $(this.scrollAreaSelector)
    scrollArea.animate({ scrollLeft: (scrollArea.scrollLeft() || 0) - this.elementWidth })
  }

  public scrollForward (): void {
    const scrollArea = $(this.scrollAreaSelector)
    scrollArea.animate({ scrollLeft: (scrollArea.scrollLeft() || 0) + this.elementWidth })
  }

  public isMobile (): boolean {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  }
}
